export const pushToGoogleAnalytics = (payload) => {
    if (payload) {
        console.log('pushing to google analytics', payload);
        window?.dataLayer?.push(payload);
    }
}